<template>
    <v-list dense class="solis-menu pa-2">
        <template v-for="(page, i) in nodes">
            <!-- Separador de seção -->
            <template v-if="page.divider">
                <v-divider :key="'div-'+i" class="my-2 mx-3"></v-divider>
                <v-subheader :key="'sub-'+i" class="solis-menu__section">{{ page.divider }}</v-subheader>
            </template>

            <!-- Item sem filhos -->
            <v-list-item v-else-if="!page.children || page.children.length === 0" :key="i" :to="page.to"
                         class="solis-menu__item" active-class="solis-menu__item--active">
                <v-list-item-icon class="mr-3">
                    <v-icon size="20">{{ page.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ page.name }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <!-- Item com filhos -->
            <v-list-group v-else :key="'g-'+i" class="solis-menu__group" active-class="solis-menu__group--active"
                          :prepend-icon="page.icon">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ page.name }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item v-for="(childPage, j) in page.children" :key="j" :to="childPage.to"
                             class="solis-menu__child" active-class="solis-menu__item--active">
                    <v-list-item-icon class="mr-3">
                        <v-icon size="16">{{ childPage.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ childPage.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </template>
    </v-list>
</template>

<script>
export default {
    name: "menubar",
    computed: {
        isAutorizado() {
            const account = localStorage.getItem('account');
            if (!account) return false;
            const { userName } = JSON.parse(account);
            const autorizados = process.env.AUTHORIZED_EMAILS.replace(/"/g, '').split(',');
            return autorizados.includes(userName);
        },
        nodes() {
            const items = [
                { name: "Início", icon: "mdi-home-outline", to: "/bemvindo" },
                { name: "Dashboard", icon: "mdi-view-dashboard-outline", to: "/dashboard" },

                { divider: "Operações" },
                {
                    name: 'Energético', icon: "mdi-solar-power-variant-outline",
                    children: [
                        { name: 'Balanços', to: "/visualizar-balanco", icon: "mdi-calendar-month-outline" },
                        { name: 'Falhas', to: "/erros-balanco", icon: "mdi-alert-circle-outline" },
                        { name: 'Setup', to: "/controle-balanco", icon: "mdi-cog-outline" },
                        { name: 'Resultados', to: "/tipos-resultado", icon: "mdi-format-list-checks" },
                        { name: 'Conformidade', to: "/testes-conformidade", icon: "mdi-shield-check-outline" },
                    ],
                },
                {
                    name: 'Financeiro', icon: "mdi-cash-multiple",
                    children: [
                        { name: 'Pré-Faturas', to: "/listagem-pre-fatura", icon: "mdi-receipt-outline" },
                        { name: 'Faturas', to: "/faturas", icon: "mdi-receipt-text-check-outline" },
                        { name: 'Descontos', to: "/descontos-extraordinarios", icon: "mdi-tag-outline" },
                        { name: 'Falhas', to: "/erros-financeiro", icon: "mdi-alert-circle-outline" },
                    ],
                },

                { divider: "Cadastros" },
                {
                    name: 'Fazendas', icon: "mdi-flash-outline",
                    children: [
                        { name: 'Setup', to: "/fazendas-setup", icon: "mdi-cog-outline" },
                        { name: 'Gerações', to: "/fazendas-ano", icon: "mdi-chart-bar" },
                    ]
                },
                {
                    name: 'Concessionárias', icon: "mdi-transmission-tower-export",
                    children: [
                        { name: 'Setup', to: "/concessionarias-setup", icon: "mdi-domain" },
                        { name: 'Tarifas', to: "/grupos-tarifarios", icon: "mdi-tag-multiple-outline" },
                    ],
                },
                {
                    name: "Tradutores", icon: "mdi-translate",
                    children: [
                        { name: "Configuração", to: "/tradutores", icon: "mdi-swap-horizontal" },
                        { name: "Painel", to: "/tradutores-painel", icon: "mdi-table" },
                    ],
                },

                { divider: "Dados & Análise" },
                { name: "Monitoramento", icon: "mdi-chart-line", to: "/monitoramento-faturas" },
                { name: "Carregar Dados", icon: "mdi-upload", to: "/formulario-faturas-distribuidoras" },
                { name: "Relatórios", icon: "mdi-file-document-outline", to: "/relatorios" },
            ];

            if (this.isAutorizado) {
                items.push({ name: "Auditoria", icon: "mdi-shield-search", to: "/auditoria" });
            }

            return items;
        },
    },
}
</script>

<style>
.solis-menu .solis-menu__section {
    font-size: 10px !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.35) !important;
    height: 24px !important;
    min-height: 24px !important;
    padding: 0 16px !important;
    margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/menubar.vue